<template>
	<div class="animate_animated animate__slideInRight">
		<!-- Header -->
		<div class="fixed w-full z-10 left-0 top-0">
			<div class="absolute w-full top-0 left-0 z-10 bg-fix">
				<div class="flex px-4 py-6 items-center ">
					<div class="w-1/2">
						<a @click="$router.go(-1)"><img src="@/assets/back-arrow-white.svg" alt=""></a>
					</div>
					<div class="w-1/2 flex justify-end">
						<span class="flex bg-white items-center rounded px-2 py-1 pointer-events-none">
							<span class="text-content text-xxs font-medium ">{{ propertyDetails.status }}</span>
						</span>
					</div>
				</div>
			</div>
			<img :src="photoUrl" alt="" class="w-full h-48 object-cover object-center">
		</div>
		<div class="mt-48 relative z-50">
			<div class="bg-gray-50 min-h-screen pb-12">
				<div class="flex items-center p-2">
					<div class="w-full">
						<div class="p-3">
							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
								<div class="flex items-center justify-between gap-2">
									<div class="flex flex-col">
										<span class="text-base text-content font-medium">&#8377; {{
											$asINR(priceinLacs(propertyDetails.expected_price)) }}</span>
										<span class="text-xs text-content text-opacity-40">Last Updated: {{
											propertyDetails.days_ago
												== 0 ? 'Today' : propertyDetails.days_ago + ' days ago' }} </span>
									</div>


									<router-link :to="{ name: 'EditProperty', params: { uuid: propertyDetails.uuid } }"
										class="cursor-pointer flex text-xs items-center gap-1 bg-gray-100 text-gray-600 px-2 py-1 rounded">
										<Edit class="size-4" /> Edit
									</router-link>
									<span v-if="created_user"
										class="text-xs text-black font-medium ml-2 mt-1 text-opacity-50">{{
											propertyDetails.user_name }}</span>
								</div>

							</div>


							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">

								<div class="flex items-center mb-1">
									<span v-if="created_user" class="text-xs text-slate-500 font-medium mr-2">{{
										propertyDetails.user_name }}</span>
									<h2 class="text-content text-base font-medium">{{ propertyDetails.title }}</h2>

								</div>
								<div class="space-y-2">
									<div class="flex justify-between items-center mb-2">
										<div class="flex  flex-col">
											<span class="block text-sm text-content mb-2">{{ propertyDetails.address
											}}</span>
											<span class="block text-sm text-slate-800" style="font-size: 12px;">Property
												No:
												{{ propertyDetails.property_no }}</span>
										</div>


									</div>

									<div class="grid grid-cols-2 gap-4">

										<div class="">
											<span class="block text-xs text-slate-500 mb-2 ">Car Parking Charge:</span>
											<span class="block text-sm text-slate-800 ">{{
												$asINR(priceinLacs(propertyDetails.car_parking_charge)) }}</span>
										</div>
										<div class="">
											<span class="block text-xs text-slate-500 mb-2 ">Base Cost Rate:</span>
											<span class="block text-sm text-slate-800 ">{{
												$asINR(priceinLacs(propertyDetails.base_cost_rate)) }}</span>
										</div>
										<div class="" v-if="propertyDetails.create_at">
											<span class="block text-xs text-slate-500 mb-2 ">Created At:</span>
											<span class="block text-sm text-slate-800 ">{{ propertyDetails.create_at
											}}</span>
										</div>
										<div class="" v-if="propertyDetails.priority">
											<span class="block text-xs text-slate-500 mb-2 ">Priority:</span>
											<span class="block text-sm text-slate-800 ">{{ propertyDetails.priority
											}}</span>
										</div>
										<div class="" v-if="propertyDetails.posession_status">
											<span class="block text-xs text-slate-500 mb-2 ">Posession Status:</span>
											<span class="block text-sm text-slate-800 ">{{
												propertyDetails.posession_status }}</span>
										</div>
									</div>

								</div>
							</div>

							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
								<div class="flex items-center gap-2 text-sm justify-center"
									@click="openGoogleMap(propertyDetails)"><Map class="size-6" /> View Location on Map
									<RightArrow class="size-4" />
								</div>
							</div>



							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
								<div class="">
									<span class="text-sm text-content text-opacity-50 block mb-2">Photos</span>
									<ImageViewer :visible="visible" :imgs="photoUrl" @hide="handleHide" />
									<div class="flex justify-between">
										<div v-for="(img_url, index) in photoUrl" :key="index"
											:class="index > 3 ? 'hidden' : ''" class="mr-2 img-gallery w-full"
											@click="() => showImg(img_url)">
											<span
												class="text-sm absolute  items-center justify-center w-full h-full text-white z-10 font-medium hidden">{{
													index
													+ 1 }}+</span>
											<img :src="img_url" alt=""
												class="w-full max-w-full rounded-sm h-20 object-cover h-fix">
										</div>
									</div>
								</div>
							</div>
							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
								<div class="grid grid-cols-2 gap-4">
									<div class="">
										<span class="block text-xs text-slate-500 mb-2 ">Build Up Area:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.builtup_area }}
											Sq.ft</span>
									</div>
									<div class="">
										<span class="block text-xs text-slate-500 mb-2 ">Carpet Area:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.carpet_area }}
											Sq.ft</span>
									</div>
								</div>

							</div>
							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
								<div class="grid grid-cols-2 gap-4">
									<div class="">
										<span class="block text-xs text-slate-500 mb-2 ">Referal Name:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.referal_name
										}}</span>
									</div>
									<div class="">
										<span class="block text-xs text-slate-500 mb-2 ">Referal Mobile:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.referal_mobile
										}}</span>
									</div>
								</div>

							</div>
							<div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
								<div class="grid grid-cols-2 gap-4">
									<div class="" v-if="propertyDetails.configuration">
										<span class="block text-xs text-slate-500 mb-2 ">Configuration:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.configuration
										}}</span>
									</div>
									<div class="" v-if="propertyDetails.bathroom">
										<span class="block text-xs text-slate-500 mb-2 ">Bathrooms:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.bathroom
											}}</span>
									</div>
									<div class="" v-if="propertyDetails.furnishing_type_id">
										<span class="block text-xs text-slate-500 mb-2 ">Furnishing Type:</span>
										<span class="block text-sm text-slate-800 ">{{
											propertyDetails.furnishing_type_id
											}}</span>
									</div>
									<div class="" v-if="propertyDetails.parking">
										<span class="block text-xs text-slate-500 mb-2 ">Parking:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.parking }}</span>
									</div>
									<div class="" v-if="propertyDetails.floor">
										<span class="block text-xs text-slate-500 mb-2 ">Floor:</span>
										<span class="block text-sm text-slate-800 ">{{ propertyDetails.floor }}</span>
									</div>
								</div>
								<div>
									<span class="block text-xs text-slate-500 mb-2 ">Property Amenities:</span>
									<span
										class="inline-block px-3 py-1 mr-2 mt-1 mb-2 rounded-full bg-slate-50 border border-slate-200 text-content text-xs font-normal"
										v-for="(am, key) in propertyDetails.amenity_ids" :key="key">{{ am.name }}
										sdsd</span>
								</div>

							</div>

							<div class=""
								v-if="(!propertyKeysList.is_executive && propertyKeysList.is_hide_owner_details)">
								<div class="flex flex-col  mt-10 mb-5">
									<div class="flex items-center flex-col justify-center mb-3"
										v-if="propertyDetails.owner">

										<User class="size-5" />
										<span
											class="bg-white  text-xxs font-medium text-main rounded-full px-3 py-1 border border-gray-100"
											style="line-height: 1;">Owner</span>
									</div>
									<span class="block text-xs text-slate-500 mb-2 text-center">{{
										propertyDetails.owner }}</span>
									<span class="block text-sm text-slate-800 text-center"
										v-if="propertyDetails.owner_contact">
										{{ propertyDetails.owner_contact }}</span>
								</div>

							</div>

							<div class=" mb-4">
								<a class="shadow-sm ring-1 ring-black/5 flex items-center justify-center gap-3 px-4 py-4 rounded-xl bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 hover:to-[#62EC14]/20 transition text-main  mb-4 "
									@click="shareWhatsApp(propertyDetails)" target="_blank">
									<WhatsApp class="size-8 text-[#00cdac]" />
									<span class="text-base ">Share on Whatsapp</span>
								</a>
							</div>


							<div class="mb-20">
								<div class="flex items-center justify-center gap-3">
									<span
										class=" text-rose-500 text-xs  font-medium  flex items-center gap-2 flex-col justify-center rounded-xl bg-rose-50 shadow-sm ring-1 ring-rose-100 p-4 min-w-20 w-full"
										@click="deleteProperty(propertyDetails.uuid)">
										<Delete class="size-5" /> Delete
									</span>

									<a @click="share = true"
										class="text-content text-xs font-medium text-opacity-50 flex items-center gap-2 flex-col justify-center rounded-xl bg-white/90 shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full">
										<Share class="size-5" /> Share
									</a>
									<a v-if="propertyDetails.brochure_url" :href="propertyDetails.brochure_url"
										class="btn text-xs text-content font-medium text-opacity-50 flex items-center gap-2 flex-col justify-center rounded-xl bg-white/90 shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full"
										target="_blank">
										<Pdf class="size-5" />Brochure
									</a>
								</div>
							</div>







						</div>
					</div>
				</div>
				<div class="fixed w-full bottom-0 bg-gradient-to-b from-gray-50 to-white">
					<div class="flex items-center p-2 py-3   justify-center">
						<div class="w-1/2" v-if="propertyDetails.matching_leads_count > 0">
							<div class="flex items-center w-full justify-center gap-2"
								@click="filterMatchesEnquiries(propertyDetails)">
								<span
									class="min-w-6 h-6 bg-success rounded-lg text-white font-semibold text-xs mr-1 flex items-center justify-center px-3">{{
										propertyDetails.matching_leads_count }}</span>
								<span class="text-base text-content font-medium">Matches</span>
							</div>
						</div>
						<div class="w-1/2"
							v-if="(!propertyKeysList.is_executive && propertyKeysList.is_hide_owner_details)">
							<div
								class="flex items-center w-full justify-center bg-primary text-white px-6 py-4 rounded-xl">
								
								<a :href="propertyDetails.owner_contact && `tel:${propertyDetails.owner_contact}`"><span
										class="text-base text-white font-medium">Call Owner</span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Modal v-model="share" header="Share with">
        <div class="flex flex-col ">
          <button
            class="flex items-center gap-3 px-4 py-3 rounded-lg bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 hover:to-[#62EC14]/20 transition text-main font-medium mb-4"
             @click="shareWhatsApp(propertyDetails)">
            <WhatsApp class="size-8 " />
            <span class="text-base font-medium">Share via WhatsApp</span>
          </button>
           <div class="flex items-center gap-3 px-4 py-3 rounded-lg  bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 transition text-main font-medium mb-4">
            <Gmail class="size-8" />
            <a :href="shareMailLink" @click="shareWithGmail(propertyDetails)" class="font-medium">Gmail</a>
          </div>
       
        </div>
      </Modal>

			
		</div>
	</div>
</template>
<script>
import { numDifferentiation } from '@/assets/scripts/utility.js';
import Modal from '@/components/Common/Modal.vue'
import ImageViewer from '@/components/Common/ImageViewer.vue'
import Delete from '@/components/icons/Delete.vue';
import Edit from '@/components/icons/Edit.vue';
import Map from '@/components/icons/Map.vue';
import RightArrow from '@/components/icons/RightArrow.vue';
import WhatsApp from '@/components/icons/WhatsApp.vue';
import Gmail from '@/components/icons/Gmail.vue';
import Share from '@/components/icons/Share.vue';
import Pdf from '@/components/icons/Pdf.vue';
import User from '@/components/icons/User.vue';
export default {
	components: {
		Modal,
		ImageViewer,
		Delete,
		Edit,
		Map,
		RightArrow,
		WhatsApp,
		Share,
		Pdf,
		User,
		Gmail
	},
	data() {
		return {
			photoUrl: [],
			imgList: [],
			share: false,
			propertyDetails: {},
			visible: false,
			index: 0,
			shareMailLink: ''
		}
	},
	created() {
		this.$store.dispatch('setnewPropertyData', {});
		this.loadPropertyDetails()
	},

	methods: {
		deleteProperty(uuid) {
			let vm = this;
			this.$swal.fire({
				title: "Delete this Property?",
				buttons: true,
				buttons: ["No", "Yes"]
			}).then(confirm => {
				if (confirm) {
					vm.$axios
						.delete(`mobile_crm/properties/${uuid}/delete`)
						.then(res => {
							this.$router.replace({ name: "Properties" });
							this.$swal.fire({
								title: "Deleted!",
								icon: "success"
							});
						})
						.catch(err => {
							this.$swal.fire({
								title: "Error",
								text: err.response.data.message,
								icon: "error"
							});
						});
				}
			});
		},
		priceinLacs(value) {
			return numDifferentiation(value)
		},
		shareWhatsApp(prop_detail) {
			let img_url = ''
			if (prop_detail.image_url) {
				prop_detail.image_url.forEach(img => {
					img_url = img_url + `%F0%9F%96%BC%EF%B8%8F+${img}%0D%0A`
				})
			}
			if (this.propertyKeysList.whatsapp_template_id == 2) {
				let brochure_url = ''
				let title = prop_detail.title ? encodeURIComponent(prop_detail.title) : ''
				if (prop_detail.brochure_url) {
					brochure_url = brochure_url + `%F0%9F%96%BC%EF%B8%8F+Brochure:+${prop_detail.brochure_url}%0D%0A`
				}
				window.open(`https://api.whatsapp.com/send?text=
        %F0%9F%8C%8D+++https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${prop_detail.lat}%2C${prop_detail.long}+%0D%0A%F0%9F%91%89+Location+%3A+${prop_detail.locality ? prop_detail.locality : ''}%0D%0A%F0%9F%91%89+Address+%3A+${prop_detail.address ? prop_detail.address : ''}%0D%0A%F0%9F%91%89+Floor+%3A+${prop_detail.floor ? prop_detail.floor : ''}%0D%0A%F0%9F%91%89+Unit+%3A+${prop_detail.unit_no ? prop_detail.unit_no : ''}%0D%0A%F0%9F%91%89+Carpet+Area%3A+${prop_detail.carpet_area}+Sq.Ft%0D%0A%F0%9F%91%89+Buildup+Area%3A+${prop_detail.builtup_area ? prop_detail.builtup_area : ''}+Sq.Ft%0D%0A%F0%9F%91%89+Furnishing +Status%3A+${prop_detail.furnishing_type_id ? prop_detail.furnishing_type_id : ''}%0D%0A%F0%9F%91%89+Furnishing+Details%3A+${prop_detail.no_of_workstations ? prop_detail.no_of_workstations : ''}%0D%0A%F0%9F%91%89+Conference+room%3A+${prop_detail.no_of_conference_room ? prop_detail.no_of_conference_room : ''}+Nos%0D%0A%F0%9F%91%89+Private+Cabin%3A+${prop_detail.no_of_cabins ? prop_detail.no_of_cabins : ''}+Nos%0D%0A%F0%9F%91%89+Car+parks%3A+${prop_detail.parking ? prop_detail.parking : ''}%0D%0A%F0%9F%91%89+Height%3A+${prop_detail.height ? prop_detail.height : ''}%0D%0A%F0%9F%91%89+Frontage%3A+${prop_detail.frontage ? prop_detail.frontage : ''}%0D%0A%F0%9F%91%89+Washroom%3A+${prop_detail.bathroom ? prop_detail.bathroom : ''}%0D%0A${img_url}${brochure_url}+%0D%0A%0D%0ATo+arrange+site+visits%2C+or+to+know+more+details+contact+%3A+%0D%0A%F0%9F%91%A4+${this.userName}%0D%0A%F0%9F%93%B1+${this.userMobile}%0D%0A%F0%9F%93%A7+${this.userEmail}${prop_detail.rera_no ? '%0D%0A%F0%9F%91%89Consultants+Rera+No%3A' + prop_detail.rera_no : ''}%0D%0A%0D%0A`)
			} else {
				let title = prop_detail.title ? encodeURIComponent(prop_detail.title) : ''
				window.open(`https://api.whatsapp.com/send?text=
          %F0%9F%8F%A8+Flat+%2F+Apartment+for+${prop_detail.property_for}%0D%0A%F0%9F%91%89+Property+Name+%3A+${title}${prop_detail.expected_price ? '%0D%0A%F0%9F%91%89+Price+%3A+' + prop_detail.expected_price : ''}${prop_detail.configuration ? '%0D%0A%F0%9F%91%89+Bedrooms+%3A+' + prop_detail.configuration : ''}${prop_detail.bathroom ? '%0D%0A%F0%9F%91%89+Bathrooms+%3A+' + prop_detail.bathroom : ''}${prop_detail.furnishing_type_id ? '%0D%0A%F0%9F%91%89+Furniture%3A+' + prop_detail.furnishing_type_id : ''}${prop_detail.builtup_area ? '%0D%0A%F0%9F%91%89+Salable+Area%3A+' + prop_detail.builtup_area + '+Sq.Ft' : ''}%0D%0A%F0%9F%91%89+Carpet+Area%3A+${prop_detail.carpet_area}+Sq.Ft%0D%0A%F0%9F%91%89+Location+%3A+${prop_detail.locality ? prop_detail.locality : ''}%2C+${prop_detail.city ? prop_detail.city : ''}${prop_detail.external_comments ? '%0D%0A%F0%9F%91%89+Additional+Information+%3A+' + prop_detail.external_comments : ''}
          %0D%0A%0D%0A%F0%9F%8C%8D+++https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${prop_detail.lat}%2C${prop_detail.long}+%0D%0A${img_url}%0D%0ATo+arrange+site+visits%2C+or+to+know+more+details+contact+%3A+%0D%0A%F0%9F%91%A4+${this.userName}%0D%0A%F0%9F%93%B1+${this.userMobile}%0D%0A%F0%9F%93%A7+${this.userEmail}${prop_detail.rera_no ? '%0D%0A%F0%9F%91%89Consultants+Rera+No%3A' + prop_detail.rera_no : ''}%0D%0A%0D%0A`)
			}

		},
		shareWithGmail(prop_detail) {
			let title = prop_detail.title ? encodeURIComponent(prop_detail.title) : ''
			let text = `%F0%9F%8F%A8 Flat %2F Apartment for ${prop_detail.property_for}%0D%0A%F0%9F%91%89 Property Name %3A ${title}%0D%0A%F0%9F%91%89 Price %3A ${prop_detail.expected_price} ${prop_detail.configuration ? '%0D%0A%F0%9F%91%89 Bedrooms %3A' + prop_detail.configuration : ''}${prop_detail.bathroom ? '%0D%0A%F0%9F%91%89 Bathrooms %3A ' + prop_detail.bathroom : ''}${prop_detail.furnishing_type_id ? '%0D%0A%F0%9F%91%89 Furniture%3A ' + prop_detail.furnishing_type_id : ''}${prop_detail.builtup_area ? '%0D%0A%F0%9F%91%89 Salable Area%3A ' + prop_detail.builtup_area + 'Sq.Ft ' : ''} %0D%0A%F0%9F%91%89 Carpet Area%3A ${prop_detail.carpet_area}Sq.Ft %0D%0A%F0%9F%91%89 Location %3A ${prop_detail.locality ? prop_detail.locality : ''}%2C ${prop_detail.city ? prop_detail.city : ''} ${prop_detail.external_comments ? '%0D%0A%F0%9F%91%89Additional Information %3A' + prop_detail.external_comments : ''}%0D%0A%0D%0A%F0%9F%91%89 https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${prop_detail.lat}%2C${prop_detail.long} %0D%0A%0D%0ATo arrange site visits%2C or to know more details contact %3A %0D%0A%F0%9F%91%A4 ${this.userName}%0D%0A%F0%9F%93%B1 ${this.userMobile}%0D%0A%F0%9F%93%A7 ${this.userEmail}${prop_detail.rera_no ? '%0D%0A%F0%9F%91%89Consultants era No%3A' + prop_detail.rera_no : ''}%0D%0A%0D%0A`
			let url = `mailto:?Subject=Property Details&body=${text}&ui=2&tf=1&pli=1`;
			this.shareMailLink = url
		},
		openGoogleMap(prop_detail) {
			window.open(`https://www.google.com/maps/search/?api=1&query=${prop_detail.lat},${prop_detail.long}`)
		},
		filterMatchesEnquiries(properties) {
			let apiParams = {}
			apiParams['locality_id'] = properties.locality_id
			apiParams['budget_from'] = properties.expected_price
			apiParams['transaction_type_id'] = properties.property_for_id
			apiParams['match'] = true
			this.$store.dispatch('setAdvSParams', apiParams);
			this.$router.push({ name: 'Enquiry' })
		},
		loadPropertyDetails() {
			this.$axios.get(`mobile_crm/properties/${this.$route.params.uuid}`)
				.then((res) => {
					this.propertyDetails = res.data.property
					this.photoUrl = this.propertyDetails.image_url
				})
				.catch((err) => console.log(err));
		},
		showImg(img_url) {
			this.imgList = img_url
			this.index = 1
			this.visible = true
		},
		handleHide() {
			this.visible = false
		}

	},
	computed: {
		userName() {
			return localStorage.getItem('property-user-name')
		},
		created_user() {
			return this.$store.getters.created_user;
		},
		userEmail() {
			return localStorage.getItem('property-user-email')
		},
		userMobile() {
			return localStorage.getItem('property-user-mobile')
		},
		propertyKeysList() {
			return this.$store.getters.propertyKeys;
		},
	}
}

</script>
<style scoped>
.amenities-label {
	@apply border-r border-divider pr-3 mr-3 inline-flex mb-2;
}

.amenities-label:first-child {
	@apply pl-0;
}

.amenities-label:last-child {
	@apply border-none;
}

.img-gallery:nth-child(4) {
	@apply relative cursor-pointer pointer-events-auto;
}

.img-gallery:nth-child(4)::after {
	@apply absolute bg-black bg-opacity-50 inset-0 rounded-sm;
	content: '';
}

.img-gallery:nth-child(4) span {
	@apply flex;
}

@media (max-width:350px) {
	.h-fix {
		height: 50px;
	}
}
</style>